import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Table } from 'primeng/table';
import { UserWalletService } from 'src/app/services/userWallet.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { LazyLoadEvent } from 'primeng/api';
import { saveAs } from 'file-saver/src/FileSaver';
import * as moment from "moment";
import { environment } from 'src/environments/environment';
import * as JSZip from 'jszip';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { Dropdown } from "primeng/dropdown";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-userinvoices',
  templateUrl: './userinvoices.component.html',
  styleUrls: ['./userinvoices.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class UserinvoicesComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  public walletlist: any = [];
  public downloadwalletlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  searchby;
  searchBy: any[];
  username: string;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  totalCash;
  totalDeductedCash;
  totalAvailableCash;
  description:any;
  endDate: Date;
  downloadFlg: boolean;
  private lastTableLazyLoadEvent: LazyLoadEvent;
  public userId;
  public loggedInUserId;
  public loggedInUserData;
  @ViewChild("dt", { static: false }) public dt: Table;
  @ViewChild("pDropDownId", { static: false }) pDropDownId: Dropdown;
  calvalue: Date;
  public hide: boolean = true;

  constructor(
    private tokenStorageService: TokenStorageService,
    private userWalletService: UserWalletService,
    private router: Router,
    private http: HttpClient,
    private messageService: MessageService, private confirmationService: ConfirmationService, private activeroute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.loggedInUserData = this.tokenStorageService.getUser();
    this.loggedInUserId = this.loggedInUserData.userdata['id'];
    this.userId = this.activeroute.snapshot.params.id;
    this.searchBy = [
      { label: 'Created On', value: "created_at" },
      { label: 'Last Modified On', value: "updated_at" }
    ];
    this.description = [
      { label: "Tournament Registration Fees", value: "Tournament Registration Fees" },
      { label: "Player registered for Tournament", value: "Player registered for Tournament" },
      { label: "Find a Partner Fees", value: "Find a Partner Fees" },
      // { label: "Cash Credited On schdeule Registration", value: "Cash Credited On schdeule Registration" },
    ];
    this.downloadFlg = false;
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = '';
    this.dt.filter('', 'id', 'contains');
    this.dt.filter('', 'userName', 'contains');
    this.dt.filter('', 'tournamentCategory', 'contains');
    this.dt.filter('', 'platformFeeAmount', 'contains');
    this.dt.filter('', 'platformFeeRate', 'contains');
    this.dt.filter('', 'convenienceFeeAmount', 'contains');
    this.dt.filter('', 'convenienceFeeRate', 'contains');
    this.dt.filter('', 'coins', 'contains');
    this.dt.filter('', 'amount', 'contains');
    this.dt.filter('', 'created_at', 'dateIs');
    this.calvalue = null;
    this.pDropDownId.clear(null);
    if (this.pDropDownId) {
      this.pDropDownId.value = null;
    }
  }

  addNewWallet() {
    this.router.navigate(['/manage/customer/user/wallet/add/' + this.userId]);
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  loadWalletHistory(event: LazyLoadEvent) {
    this.lastTableLazyLoadEvent = event;
   // var query = "?filterByDisable=false&showAll=true&filterByAction=SUBTRACT"; //&filterByUserid=" + this.userId;
    var query = "?filterByDisable=false"; 
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = (event.first / event.rows) + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }
    if (this.searchby != undefined && this.startDate != undefined && this.endDate != undefined) {
      params += "&filterByDate=" + this.searchby.value;
      params += "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }
    if (event.filters?.["id"]?.value) {
        params += "&filterById=" + event.filters["id"].value;
    }
    if (event.filters?.["userName"]?.value) {
        params += "&filterByName=" + event.filters["userName"].value;
    }
    if (event.filters?.["description"]?.value) {
        params += "&filterByDescription=" + event.filters["description"].value;
    }
    if (event.filters?.["tournamentCategory"]?.value) {
        params += "&filterByTournamentCategory=" + event.filters["tournamentCategory"].value;
    }
    if (event.filters?.["platformFeeAmount"]?.value) {
        params += "&filterByPlatformFeeAmount=" + event.filters["platformFeeAmount"].value;
    }
    if (event.filters?.["platformFeeRate"]?.value) {
        params += "&filterByPlatformFeeRate=" + event.filters["platformFeeRate"].value;
    }
    if (event.filters?.["convenienceFeeAmount"]?.value) {
        params += "&filterByConvenienceFeeAmount=" + event.filters["convenienceFeeAmount"].value;
    }
    if (event.filters?.["convenienceFeeRate"]?.value) {
        params += "&filterByConvenienceFeeRate=" + event.filters["convenienceFeeRate"].value;
    }
    if (event.filters?.["amount"]?.value) {
        params += "&filterByAmount=" + event.filters["amount"].value;
    }
    if (event.filters?.["amountPaid"]?.value) {
        params += "&filterByFinalPaybleAmountPaid=" + event.filters["amountPaid"].value;
    }
    if (event.filters?.["created_at"]?.value) {
        const createdAt = moment(event.filters["created_at"].value).format("YYYY-MM-DD");
        params += "&filterByCreatedAt=" + createdAt;
    }
    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }
    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "DESC";
      } else {
        orderBy = "ASC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    // this.userWalletService.getUserWalletList(query)
    this.userWalletService.getUserInvoiceList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        this.loading = false;
        if (this.downloadFlg === true) {
          this.exportExcelsheet(data.data.items);
        } else{
        // this.username = data.data.userInfo['name'];
        // this.totalCash = data.data.totalCash;
        // this.totalDeductedCash = data.data.totalDeductedCash;
        // this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        // this.totalCoins = data.data.totalCoins;
        // this.totalDeductedCoin = data.data.totalDeductedCoin;
        // this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.walletlist = data.data.items;
        this.totalRecords = data.data.totalCount;
        }

      },
      err => {
        this.errorMessage = err.error.message;
      });
  }
  exportExcel(){
    this.downloadFlg = true;
    this.loadWalletHistory(this.lastTableLazyLoadEvent);
  }

  exportExcelsheet(walletlist) {
    var propertiesRemove = [
      'tournamentplayerdata', 'contestdata', 'userId', 'status',
      'created_by', 'createdBy', 'updatedby', 'disable', 'updated_at',
      'invoiceData', 'userData', 'payment_flag'
    ];

    this.downloadwalletlist = walletlist;

    const paymentFlagMap: Map<number, number> = new Map();
    this.downloadwalletlist.forEach((item, index) => {
      paymentFlagMap.set(index, item.payment_flag ?? 1);
    });

    const totals = {
      totalProductAmountReceived: 0,
      igstAmountReceived: 0,
      sgstAmountReceived: 0,
      cgstAmountReceived: 0,
      totalTaxableAmountReceived: 0,
      totalGstAmountReceived: 0,
      totalPlatformFeeAmountReceived: 0,
      totalConvenienceFeeAmountReceived: 0,
      totalfinalPayableAmountReceived: 0,
      totalProductAmountReturned: 0,
      igstAmountReturned: 0,
      sgstAmountReturned: 0,
      cgstAmountReturned: 0,
      totalTaxableAmountReturned: 0,
      totalGstAmountReturned: 0,
      totalPlatformFeeAmountReturned: 0,
      totalConvenienceFeeAmountReturned: 0,
      totalfinalPayableAmountReturned: 0,
    };

    this.downloadwalletlist.forEach(function (item) {
      if (item.action !== 'ADD' && item.payment_flag !== 0) {
        totals.totalProductAmountReceived += Number(item.totalProductAmount || 0);
        totals.igstAmountReceived += Number(item.igstAmount || 0);
        totals.sgstAmountReceived += Number(item.sgstAmount || 0);
        totals.cgstAmountReceived += Number(item.cgstAmount || 0);
        totals.totalTaxableAmountReceived += Number(item.totalTaxableAmount || 0);
        totals.totalGstAmountReceived += Number(item.totalGstAmount || 0);
        totals.totalPlatformFeeAmountReceived += Number(item.platformFeeAmount || 0);
        totals.totalConvenienceFeeAmountReceived += Number(item.convenienceFeeAmount || 0);
        totals.totalfinalPayableAmountReceived += Number(item.finalPayableAmount || 0);
      }

      if (item.action !== 'SUBTRACT' && item.payment_flag !== 0) {
        totals.totalProductAmountReturned += Number(item.totalProductAmount || 0);
        totals.igstAmountReturned += Number(item.igstAmount || 0);
        totals.sgstAmountReturned += Number(item.sgstAmount || 0);
        totals.cgstAmountReturned += Number(item.cgstAmount || 0);
        totals.totalTaxableAmountReturned += Number(item.totalTaxableAmount || 0);
        totals.totalGstAmountReturned += Number(item.totalGstAmount || 0);
        totals.totalPlatformFeeAmountReturned += Number(item.platformFeeAmount || 0);
        totals.totalConvenienceFeeAmountReturned += Number(item.convenienceFeeAmount || 0);
        totals.totalfinalPayableAmountReturned += Number(item.finalPayableAmount || 0);
      }

      if (item.created_at != '') {
        item['created_at'] = moment(item.created_at).format('DD-MM-YYYY');
      }
      propertiesRemove.forEach(function (prop) {
        delete item[prop];
      });
    });

    const columnMapping: { [key: string]: string } = {
      'id': 'ID',
      'wallettype': 'Wallet Type',
      'creditInvoiceFile': 'Credit Invoice File',
      'userName': 'User Name',
      'amount': 'Amount',
      'description': 'Description',
      'action': 'Action',
      'created_at': 'Created At',
      'invoiceId': 'Invoice ID',
      'creditInvoiceId': 'Credit Invoice Id',
      'ProductHSN': 'Product HSN',
      'ProductQuantity': 'Product Quantity',
      'totalProductAmount': 'Total Product Amount',
      'tournamentCategory': 'Tournament Category',
      'platformFeeAmount': 'Platform Fee Amount',
      'platformFeeRate': 'Platform Fee Rate',
      'convenienceFeeAmount': 'Convenience Fee Amount',
      'convenienceFeeRate': 'Convenience Fee Rate',
      'igstPercentage': 'IGST Percentage',
      'igstAmount': 'IGST Amount',
      'sgstPercentage': 'SGST Percentage',
      'sgstAmount': 'SGST Amount',
      'cgstPercentage': 'CGST Percentage',
      'cgstAmount': 'CGST Amount',
      'totalTaxableAmount': 'Total Taxable Amount',
      'totalGstAmount': 'Total GST Amount',
      'finalPayableAmount': 'Final Payable Amount',
      'ProductRate': 'Product Rate',
      'placeOfSupply': 'Place of Supply',
      'invoiceFile': 'Invoice File',
    };

    const headers = Object.values(columnMapping);

    const mappedData = this.downloadwalletlist.map(item => {
      const newItem: { [key: string]: any } = {};
      for (const key in item) {
        if (columnMapping.hasOwnProperty(key)) {
          newItem[columnMapping[key]] = item[key];
        }
      }
      return newItem;
    });

    import('exceljs').then(({ Workbook }) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('data');

      const yellowFill: any = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' }
      };

      const greyFill: any = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD9D9D9' }
      };

      const boldFont = { bold: true };

      const userInvoiceSummaryHeader = worksheet.addRow(['User Invoice Summary : ']);
      userInvoiceSummaryHeader.eachCell(cell => { cell.font = boldFont; });
      
      const summaryHeaders1 = [
        'Sum of Total Product Amount', 'Sum of IGST Amount', 'Sum of SGST Amount',
        'Sum of CGST Amount', 'Sum of Total Taxable Amount', 'Sum of Total GST Amount',
        'Sum of Total Platform Fee Amount', 'Sum of Total Convenience Fee Amount',
        'Sum of Total Final Payable Amount'
      ];
      const summaryHeaderRow1 = worksheet.addRow(summaryHeaders1);
      summaryHeaderRow1.eachCell(cell => { cell.font = boldFont; });

      worksheet.addRow([
        Number(totals.totalProductAmountReceived).toFixed(2),
        Number(totals.igstAmountReceived).toFixed(2),
        Number(totals.sgstAmountReceived).toFixed(2),
        Number(totals.cgstAmountReceived).toFixed(2),
        Number(totals.totalTaxableAmountReceived).toFixed(2),
        Number(totals.totalGstAmountReceived).toFixed(2),
        Number(totals.totalPlatformFeeAmountReceived).toFixed(2),
        Number(totals.totalConvenienceFeeAmountReceived).toFixed(2),
        Number(totals.totalfinalPayableAmountReceived).toFixed(2),
      ]);

      worksheet.addRow([]);

      const creditNoteSummaryHeader = worksheet.addRow(['Credit Note Summary : ']);
      creditNoteSummaryHeader.eachCell(cell => { cell.font = boldFont; });
      
      const summaryHeaders2 = [
        'Sum of Total Product Amount', 'Sum of IGST Amount', 'Sum of SGST Amount',
        'Sum of CGST Amount', 'Sum of Total Taxable Amount', 'Sum of Total GST Amount',
        'Sum of Total Platform Fee Amount', 'Sum of Total Convenience Fee Amount',
        'Sum of Total Final Payable Amount'
      ];
      const summaryHeaderRow2 = worksheet.addRow(summaryHeaders2);
      summaryHeaderRow2.eachCell(cell => { cell.font = boldFont; });

      worksheet.addRow([
        Number(totals.totalProductAmountReturned).toFixed(2),
        Number(totals.igstAmountReturned).toFixed(2),
        Number(totals.sgstAmountReturned).toFixed(2),
        Number(totals.cgstAmountReturned).toFixed(2),
        Number(totals.totalTaxableAmountReturned).toFixed(2),
        Number(totals.totalGstAmountReturned).toFixed(2),
        Number(totals.totalPlatformFeeAmountReturned).toFixed(2),
        Number(totals.totalConvenienceFeeAmountReturned).toFixed(2),
        Number(totals.totalfinalPayableAmountReturned).toFixed(2),
      ]);

      worksheet.addRow([]);

      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell(cell => {
        cell.font = boldFont;
        cell.fill = greyFill;
      });

      mappedData.forEach((rowData, rowIndex) => {
        const values = headers.map(h => rowData[h] ?? '');
        const dataRow = worksheet.addRow(values);

        if (paymentFlagMap.get(rowIndex) === 0) {
          dataRow.eachCell({ includeEmpty: true }, cell => {
            cell.fill = yellowFill;
          });
        }
      });

      workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
        this.saveAsExcelFile(buffer, 'Wallet History');
      });
    });

    this.downloadFlg = false;
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then(FileSaver => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  deleteUserWalletEntry(userWalletEntry) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete this entry ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        var disableStatus;
        if (userWalletEntry.disable == false) {
          disableStatus = true;
        } else {
          disableStatus = false;
        }
        var userWalletEntryData = '{"disable":' + disableStatus + '}';
        this.userWalletService.updateUserWallet(userWalletEntry.id, userWalletEntryData).pipe(takeUntil(this.destroy$)).subscribe(
          data => {
            this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'User Wallet Entry Deleted', life: 3000 });
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
          },
          err => {
            this.loadWalletHistory(this.lastTableLazyLoadEvent);
            this.errorMessage = err.error.message;
          }
        );
      },
      reject: () => {
        //this.getUserDetails(user.id);
      }
    });
  }
  downloadPdf(invoiceFile) {
    window.open(invoiceFile);
  }

  generateAndDownloadZip() {
    const zip = new JSZip();
    this.downloadwalletlist = this.walletlist;
    const pdfObservables = [];

    this.downloadwalletlist.forEach((el) => {
      if(el.invoiceFile){
        pdfObservables.push(
          this.http.get(el.invoiceFile, { responseType: 'blob' })
        );
      }else if(el.creditInvoiceFile){
         pdfObservables.push(
          this.http.get(el.creditInvoiceFile, { responseType: 'blob' })
        );
      }
     
    });

    forkJoin(pdfObservables).pipe(takeUntil(this.destroy$)).subscribe((pdfBlobs:any) => {
      pdfBlobs.forEach((pdfBlob, index) => {
        zip.file(`${this.downloadwalletlist[index].id}.pdf`, pdfBlob);
      });    
      zip.generateAsync({ type: 'blob' }).then((blob) => {
        saveAs(blob, `User_Invoice_${new Date().getTime()}.zip`);
      });
    });
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
